/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SupportRouteImport } from './routes/support'
import { Route as AdminPersonInfoRouteImport } from './routes/admin/person-info'
import { Route as AdminPpnMasterdataImportRouteImport } from './routes/admin/ppn-masterdata-import'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as NewsFeatureArticleIdRouteImport } from './routes/news/$featureArticleId'
import { Route as ProfileEmailNotificationsRouteImport } from './routes/profile/email-notifications'
import { Route as ProfileGeneralSettingsRouteImport } from './routes/profile/general-settings'
import { Route as SupportUserFeedbacksRouteImport } from './routes/support/user-feedbacks'
import { Route as AdminAnalyticsAuthRouteImport } from './routes/admin/analytics/_auth'
import { Route as AdminAnnouncementsAuthRouteImport } from './routes/admin/announcements/_auth'
import { Route as AdminNewsAuthRouteImport } from './routes/admin/news/_auth'
import { Route as AdminOrganizationInfoAuthRouteImport } from './routes/admin/organization-info/_auth'
import { Route as AdminPersonInfoPersonIdRouteImport } from './routes/admin/person-info/$personId'
import { Route as AdminPpnMasterdataImportMovedOrganizationsRouteImport } from './routes/admin/ppn-masterdata-import/moved-organizations'
import { Route as AdminPpnMasterdataImportStatusRouteImport } from './routes/admin/ppn-masterdata-import/status'
import { Route as AdminUserManagementAuthRouteImport } from './routes/admin/user-management/_auth'
import { Route as SupportRequestsIndexRouteImport } from './routes/support/requests/index'
import { Route as SupportRequestsRequestIdRouteImport } from './routes/support/requests/$requestId'
import { Route as AdminAnalyticsAuthIndexRouteImport } from './routes/admin/analytics/_auth.index'
import { Route as AdminAnnouncementsAuthIndexRouteImport } from './routes/admin/announcements/_auth.index'
import { Route as AdminNewsAuthIndexRouteImport } from './routes/admin/news/_auth.index'
import { Route as AdminOrganizationInfoAuthIndexRouteImport } from './routes/admin/organization-info/_auth.index'
import { Route as AdminPersonInfoPersonIdAppRouteImport } from './routes/admin/person-info/$personId/$app'
import { Route as AdminPersonInfoPersonIdAccountRouteImport } from './routes/admin/person-info/$personId/account'
import { Route as AdminPersonInfoPersonIdConsentsRouteImport } from './routes/admin/person-info/$personId/consents'
import { Route as AdminPersonInfoPersonIdGroupsRouteImport } from './routes/admin/person-info/$personId/groups'
import { Route as AdminPersonInfoPersonIdOrganizationsRouteImport } from './routes/admin/person-info/$personId/organizations'
import { Route as AdminPersonInfoPersonIdSettingsRouteImport } from './routes/admin/person-info/$personId/settings'
import { Route as AdminUserManagementAuthIndexRouteImport } from './routes/admin/user-management/_auth.index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const ImprintRoute = ImprintRouteImport.update({
  id: '/imprint',
  path: '/imprint',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPersonInfoRoute = AdminPersonInfoRouteImport.update({
  id: '/admin/person-info',
  path: '/admin/person-info',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPpnMasterdataImportRoute =
  AdminPpnMasterdataImportRouteImport.update({
    id: '/admin/ppn-masterdata-import',
    path: '/admin/ppn-masterdata-import',
    getParentRoute: () => rootRouteImport,
  } as any)
const NewsIndexRoute = NewsIndexRouteImport.update({
  id: '/news/',
  path: '/news/',
  getParentRoute: () => rootRouteImport,
} as any)
const NewsFeatureArticleIdRoute = NewsFeatureArticleIdRouteImport.update({
  id: '/news/$featureArticleId',
  path: '/news/$featureArticleId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEmailNotificationsRoute =
  ProfileEmailNotificationsRouteImport.update({
    id: '/email-notifications',
    path: '/email-notifications',
    getParentRoute: () => ProfileRoute,
  } as any)
const ProfileGeneralSettingsRoute = ProfileGeneralSettingsRouteImport.update({
  id: '/general-settings',
  path: '/general-settings',
  getParentRoute: () => ProfileRoute,
} as any)
const SupportUserFeedbacksRoute = SupportUserFeedbacksRouteImport.update({
  id: '/user-feedbacks',
  path: '/user-feedbacks',
  getParentRoute: () => SupportRoute,
} as any)
const AdminAnalyticsAuthRoute = AdminAnalyticsAuthRouteImport.update({
  id: '/admin/analytics/_auth',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnnouncementsAuthRoute = AdminAnnouncementsAuthRouteImport.update({
  id: '/admin/announcements/_auth',
  path: '/admin/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewsAuthRoute = AdminNewsAuthRouteImport.update({
  id: '/admin/news/_auth',
  path: '/admin/news',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationInfoAuthRoute =
  AdminOrganizationInfoAuthRouteImport.update({
    id: '/admin/organization-info/_auth',
    path: '/admin/organization-info',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminPersonInfoPersonIdRoute = AdminPersonInfoPersonIdRouteImport.update({
  id: '/$personId',
  path: '/$personId',
  getParentRoute: () => AdminPersonInfoRoute,
} as any)
const AdminPpnMasterdataImportMovedOrganizationsRoute =
  AdminPpnMasterdataImportMovedOrganizationsRouteImport.update({
    id: '/moved-organizations',
    path: '/moved-organizations',
    getParentRoute: () => AdminPpnMasterdataImportRoute,
  } as any)
const AdminPpnMasterdataImportStatusRoute =
  AdminPpnMasterdataImportStatusRouteImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => AdminPpnMasterdataImportRoute,
  } as any)
const AdminUserManagementAuthRoute = AdminUserManagementAuthRouteImport.update({
  id: '/admin/user-management/_auth',
  path: '/admin/user-management',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRequestsIndexRoute = SupportRequestsIndexRouteImport.update({
  id: '/requests/',
  path: '/requests/',
  getParentRoute: () => SupportRoute,
} as any)
const SupportRequestsRequestIdRoute =
  SupportRequestsRequestIdRouteImport.update({
    id: '/requests/$requestId',
    path: '/requests/$requestId',
    getParentRoute: () => SupportRoute,
  } as any)
const AdminAnalyticsAuthIndexRoute = AdminAnalyticsAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminAnalyticsAuthRoute,
} as any)
const AdminAnnouncementsAuthIndexRoute =
  AdminAnnouncementsAuthIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminAnnouncementsAuthRoute,
  } as any)
const AdminNewsAuthIndexRoute = AdminNewsAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminNewsAuthRoute,
} as any)
const AdminOrganizationInfoAuthIndexRoute =
  AdminOrganizationInfoAuthIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminOrganizationInfoAuthRoute,
  } as any)
const AdminPersonInfoPersonIdAppRoute =
  AdminPersonInfoPersonIdAppRouteImport.update({
    id: '/$app',
    path: '/$app',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminPersonInfoPersonIdAccountRoute =
  AdminPersonInfoPersonIdAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminPersonInfoPersonIdConsentsRoute =
  AdminPersonInfoPersonIdConsentsRouteImport.update({
    id: '/consents',
    path: '/consents',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminPersonInfoPersonIdGroupsRoute =
  AdminPersonInfoPersonIdGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminPersonInfoPersonIdOrganizationsRoute =
  AdminPersonInfoPersonIdOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminPersonInfoPersonIdSettingsRoute =
  AdminPersonInfoPersonIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AdminPersonInfoPersonIdRoute,
  } as any)
const AdminUserManagementAuthIndexRoute =
  AdminUserManagementAuthIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminUserManagementAuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRoute
  '/imprint': typeof ImprintRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/admin/person-info': typeof AdminPersonInfoRouteWithChildren
  '/admin/ppn-masterdata-import': typeof AdminPpnMasterdataImportRouteWithChildren
  '/news/$featureArticleId': typeof NewsFeatureArticleIdRoute
  '/profile/email-notifications': typeof ProfileEmailNotificationsRoute
  '/profile/general-settings': typeof ProfileGeneralSettingsRoute
  '/support/user-feedbacks': typeof SupportUserFeedbacksRoute
  '/news/': typeof NewsIndexRoute
  '/admin/analytics': typeof AdminAnalyticsAuthRouteWithChildren
  '/admin/announcements': typeof AdminAnnouncementsAuthRouteWithChildren
  '/admin/news': typeof AdminNewsAuthRouteWithChildren
  '/admin/organization-info': typeof AdminOrganizationInfoAuthRouteWithChildren
  '/admin/person-info/$personId': typeof AdminPersonInfoPersonIdRouteWithChildren
  '/admin/ppn-masterdata-import/moved-organizations': typeof AdminPpnMasterdataImportMovedOrganizationsRoute
  '/admin/ppn-masterdata-import/status': typeof AdminPpnMasterdataImportStatusRoute
  '/admin/user-management': typeof AdminUserManagementAuthRouteWithChildren
  '/support/requests/$requestId': typeof SupportRequestsRequestIdRoute
  '/support/requests/': typeof SupportRequestsIndexRoute
  '/admin/person-info/$personId/$app': typeof AdminPersonInfoPersonIdAppRoute
  '/admin/person-info/$personId/account': typeof AdminPersonInfoPersonIdAccountRoute
  '/admin/person-info/$personId/consents': typeof AdminPersonInfoPersonIdConsentsRoute
  '/admin/person-info/$personId/groups': typeof AdminPersonInfoPersonIdGroupsRoute
  '/admin/person-info/$personId/organizations': typeof AdminPersonInfoPersonIdOrganizationsRoute
  '/admin/person-info/$personId/settings': typeof AdminPersonInfoPersonIdSettingsRoute
  '/admin/analytics/': typeof AdminAnalyticsAuthIndexRoute
  '/admin/announcements/': typeof AdminAnnouncementsAuthIndexRoute
  '/admin/news/': typeof AdminNewsAuthIndexRoute
  '/admin/organization-info/': typeof AdminOrganizationInfoAuthIndexRoute
  '/admin/user-management/': typeof AdminUserManagementAuthIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRoute
  '/imprint': typeof ImprintRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/admin/person-info': typeof AdminPersonInfoRouteWithChildren
  '/admin/ppn-masterdata-import': typeof AdminPpnMasterdataImportRouteWithChildren
  '/news/$featureArticleId': typeof NewsFeatureArticleIdRoute
  '/profile/email-notifications': typeof ProfileEmailNotificationsRoute
  '/profile/general-settings': typeof ProfileGeneralSettingsRoute
  '/support/user-feedbacks': typeof SupportUserFeedbacksRoute
  '/news': typeof NewsIndexRoute
  '/admin/person-info/$personId': typeof AdminPersonInfoPersonIdRouteWithChildren
  '/admin/ppn-masterdata-import/moved-organizations': typeof AdminPpnMasterdataImportMovedOrganizationsRoute
  '/admin/ppn-masterdata-import/status': typeof AdminPpnMasterdataImportStatusRoute
  '/support/requests/$requestId': typeof SupportRequestsRequestIdRoute
  '/support/requests': typeof SupportRequestsIndexRoute
  '/admin/person-info/$personId/$app': typeof AdminPersonInfoPersonIdAppRoute
  '/admin/person-info/$personId/account': typeof AdminPersonInfoPersonIdAccountRoute
  '/admin/person-info/$personId/consents': typeof AdminPersonInfoPersonIdConsentsRoute
  '/admin/person-info/$personId/groups': typeof AdminPersonInfoPersonIdGroupsRoute
  '/admin/person-info/$personId/organizations': typeof AdminPersonInfoPersonIdOrganizationsRoute
  '/admin/person-info/$personId/settings': typeof AdminPersonInfoPersonIdSettingsRoute
  '/admin/analytics': typeof AdminAnalyticsAuthIndexRoute
  '/admin/announcements': typeof AdminAnnouncementsAuthIndexRoute
  '/admin/news': typeof AdminNewsAuthIndexRoute
  '/admin/organization-info': typeof AdminOrganizationInfoAuthIndexRoute
  '/admin/user-management': typeof AdminUserManagementAuthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cookie-policy': typeof CookiePolicyRoute
  '/help': typeof HelpRoute
  '/imprint': typeof ImprintRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRouteWithChildren
  '/support': typeof SupportRouteWithChildren
  '/admin/person-info': typeof AdminPersonInfoRouteWithChildren
  '/admin/ppn-masterdata-import': typeof AdminPpnMasterdataImportRouteWithChildren
  '/news/$featureArticleId': typeof NewsFeatureArticleIdRoute
  '/profile/email-notifications': typeof ProfileEmailNotificationsRoute
  '/profile/general-settings': typeof ProfileGeneralSettingsRoute
  '/support/user-feedbacks': typeof SupportUserFeedbacksRoute
  '/news/': typeof NewsIndexRoute
  '/admin/analytics/_auth': typeof AdminAnalyticsAuthRouteWithChildren
  '/admin/announcements/_auth': typeof AdminAnnouncementsAuthRouteWithChildren
  '/admin/news/_auth': typeof AdminNewsAuthRouteWithChildren
  '/admin/organization-info/_auth': typeof AdminOrganizationInfoAuthRouteWithChildren
  '/admin/person-info/$personId': typeof AdminPersonInfoPersonIdRouteWithChildren
  '/admin/ppn-masterdata-import/moved-organizations': typeof AdminPpnMasterdataImportMovedOrganizationsRoute
  '/admin/ppn-masterdata-import/status': typeof AdminPpnMasterdataImportStatusRoute
  '/admin/user-management/_auth': typeof AdminUserManagementAuthRouteWithChildren
  '/support/requests/$requestId': typeof SupportRequestsRequestIdRoute
  '/support/requests/': typeof SupportRequestsIndexRoute
  '/admin/person-info/$personId/$app': typeof AdminPersonInfoPersonIdAppRoute
  '/admin/person-info/$personId/account': typeof AdminPersonInfoPersonIdAccountRoute
  '/admin/person-info/$personId/consents': typeof AdminPersonInfoPersonIdConsentsRoute
  '/admin/person-info/$personId/groups': typeof AdminPersonInfoPersonIdGroupsRoute
  '/admin/person-info/$personId/organizations': typeof AdminPersonInfoPersonIdOrganizationsRoute
  '/admin/person-info/$personId/settings': typeof AdminPersonInfoPersonIdSettingsRoute
  '/admin/analytics/_auth/': typeof AdminAnalyticsAuthIndexRoute
  '/admin/announcements/_auth/': typeof AdminAnnouncementsAuthIndexRoute
  '/admin/news/_auth/': typeof AdminNewsAuthIndexRoute
  '/admin/organization-info/_auth/': typeof AdminOrganizationInfoAuthIndexRoute
  '/admin/user-management/_auth/': typeof AdminUserManagementAuthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cookie-policy'
    | '/help'
    | '/imprint'
    | '/privacy-policy'
    | '/profile'
    | '/support'
    | '/admin/person-info'
    | '/admin/ppn-masterdata-import'
    | '/news/$featureArticleId'
    | '/profile/email-notifications'
    | '/profile/general-settings'
    | '/support/user-feedbacks'
    | '/news/'
    | '/admin/analytics'
    | '/admin/announcements'
    | '/admin/news'
    | '/admin/organization-info'
    | '/admin/person-info/$personId'
    | '/admin/ppn-masterdata-import/moved-organizations'
    | '/admin/ppn-masterdata-import/status'
    | '/admin/user-management'
    | '/support/requests/$requestId'
    | '/support/requests/'
    | '/admin/person-info/$personId/$app'
    | '/admin/person-info/$personId/account'
    | '/admin/person-info/$personId/consents'
    | '/admin/person-info/$personId/groups'
    | '/admin/person-info/$personId/organizations'
    | '/admin/person-info/$personId/settings'
    | '/admin/analytics/'
    | '/admin/announcements/'
    | '/admin/news/'
    | '/admin/organization-info/'
    | '/admin/user-management/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cookie-policy'
    | '/help'
    | '/imprint'
    | '/privacy-policy'
    | '/profile'
    | '/support'
    | '/admin/person-info'
    | '/admin/ppn-masterdata-import'
    | '/news/$featureArticleId'
    | '/profile/email-notifications'
    | '/profile/general-settings'
    | '/support/user-feedbacks'
    | '/news'
    | '/admin/person-info/$personId'
    | '/admin/ppn-masterdata-import/moved-organizations'
    | '/admin/ppn-masterdata-import/status'
    | '/support/requests/$requestId'
    | '/support/requests'
    | '/admin/person-info/$personId/$app'
    | '/admin/person-info/$personId/account'
    | '/admin/person-info/$personId/consents'
    | '/admin/person-info/$personId/groups'
    | '/admin/person-info/$personId/organizations'
    | '/admin/person-info/$personId/settings'
    | '/admin/analytics'
    | '/admin/announcements'
    | '/admin/news'
    | '/admin/organization-info'
    | '/admin/user-management'
  id:
    | '__root__'
    | '/'
    | '/cookie-policy'
    | '/help'
    | '/imprint'
    | '/privacy-policy'
    | '/profile'
    | '/support'
    | '/admin/person-info'
    | '/admin/ppn-masterdata-import'
    | '/news/$featureArticleId'
    | '/profile/email-notifications'
    | '/profile/general-settings'
    | '/support/user-feedbacks'
    | '/news/'
    | '/admin/analytics/_auth'
    | '/admin/announcements/_auth'
    | '/admin/news/_auth'
    | '/admin/organization-info/_auth'
    | '/admin/person-info/$personId'
    | '/admin/ppn-masterdata-import/moved-organizations'
    | '/admin/ppn-masterdata-import/status'
    | '/admin/user-management/_auth'
    | '/support/requests/$requestId'
    | '/support/requests/'
    | '/admin/person-info/$personId/$app'
    | '/admin/person-info/$personId/account'
    | '/admin/person-info/$personId/consents'
    | '/admin/person-info/$personId/groups'
    | '/admin/person-info/$personId/organizations'
    | '/admin/person-info/$personId/settings'
    | '/admin/analytics/_auth/'
    | '/admin/announcements/_auth/'
    | '/admin/news/_auth/'
    | '/admin/organization-info/_auth/'
    | '/admin/user-management/_auth/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CookiePolicyRoute: typeof CookiePolicyRoute
  HelpRoute: typeof HelpRoute
  ImprintRoute: typeof ImprintRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  SupportRoute: typeof SupportRouteWithChildren
  AdminPersonInfoRoute: typeof AdminPersonInfoRouteWithChildren
  AdminPpnMasterdataImportRoute: typeof AdminPpnMasterdataImportRouteWithChildren
  NewsFeatureArticleIdRoute: typeof NewsFeatureArticleIdRoute
  NewsIndexRoute: typeof NewsIndexRoute
  AdminAnalyticsAuthRoute: typeof AdminAnalyticsAuthRouteWithChildren
  AdminAnnouncementsAuthRoute: typeof AdminAnnouncementsAuthRouteWithChildren
  AdminNewsAuthRoute: typeof AdminNewsAuthRouteWithChildren
  AdminOrganizationInfoAuthRoute: typeof AdminOrganizationInfoAuthRouteWithChildren
  AdminUserManagementAuthRoute: typeof AdminUserManagementAuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imprint': {
      id: '/imprint'
      path: '/imprint'
      fullPath: '/imprint'
      preLoaderRoute: typeof ImprintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/person-info': {
      id: '/admin/person-info'
      path: '/admin/person-info'
      fullPath: '/admin/person-info'
      preLoaderRoute: typeof AdminPersonInfoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ppn-masterdata-import': {
      id: '/admin/ppn-masterdata-import'
      path: '/admin/ppn-masterdata-import'
      fullPath: '/admin/ppn-masterdata-import'
      preLoaderRoute: typeof AdminPpnMasterdataImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/': {
      id: '/news/'
      path: '/news'
      fullPath: '/news/'
      preLoaderRoute: typeof NewsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/news/$featureArticleId': {
      id: '/news/$featureArticleId'
      path: '/news/$featureArticleId'
      fullPath: '/news/$featureArticleId'
      preLoaderRoute: typeof NewsFeatureArticleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/email-notifications': {
      id: '/profile/email-notifications'
      path: '/email-notifications'
      fullPath: '/profile/email-notifications'
      preLoaderRoute: typeof ProfileEmailNotificationsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/profile/general-settings': {
      id: '/profile/general-settings'
      path: '/general-settings'
      fullPath: '/profile/general-settings'
      preLoaderRoute: typeof ProfileGeneralSettingsRouteImport
      parentRoute: typeof ProfileRoute
    }
    '/support/user-feedbacks': {
      id: '/support/user-feedbacks'
      path: '/user-feedbacks'
      fullPath: '/support/user-feedbacks'
      preLoaderRoute: typeof SupportUserFeedbacksRouteImport
      parentRoute: typeof SupportRoute
    }
    '/admin/analytics/_auth': {
      id: '/admin/analytics/_auth'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/announcements/_auth': {
      id: '/admin/announcements/_auth'
      path: '/admin/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/news/_auth': {
      id: '/admin/news/_auth'
      path: '/admin/news'
      fullPath: '/admin/news'
      preLoaderRoute: typeof AdminNewsAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organization-info/_auth': {
      id: '/admin/organization-info/_auth'
      path: '/admin/organization-info'
      fullPath: '/admin/organization-info'
      preLoaderRoute: typeof AdminOrganizationInfoAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/person-info/$personId': {
      id: '/admin/person-info/$personId'
      path: '/$personId'
      fullPath: '/admin/person-info/$personId'
      preLoaderRoute: typeof AdminPersonInfoPersonIdRouteImport
      parentRoute: typeof AdminPersonInfoRoute
    }
    '/admin/ppn-masterdata-import/moved-organizations': {
      id: '/admin/ppn-masterdata-import/moved-organizations'
      path: '/moved-organizations'
      fullPath: '/admin/ppn-masterdata-import/moved-organizations'
      preLoaderRoute: typeof AdminPpnMasterdataImportMovedOrganizationsRouteImport
      parentRoute: typeof AdminPpnMasterdataImportRoute
    }
    '/admin/ppn-masterdata-import/status': {
      id: '/admin/ppn-masterdata-import/status'
      path: '/status'
      fullPath: '/admin/ppn-masterdata-import/status'
      preLoaderRoute: typeof AdminPpnMasterdataImportStatusRouteImport
      parentRoute: typeof AdminPpnMasterdataImportRoute
    }
    '/admin/user-management/_auth': {
      id: '/admin/user-management/_auth'
      path: '/admin/user-management'
      fullPath: '/admin/user-management'
      preLoaderRoute: typeof AdminUserManagementAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/requests/': {
      id: '/support/requests/'
      path: '/requests'
      fullPath: '/support/requests/'
      preLoaderRoute: typeof SupportRequestsIndexRouteImport
      parentRoute: typeof SupportRoute
    }
    '/support/requests/$requestId': {
      id: '/support/requests/$requestId'
      path: '/requests/$requestId'
      fullPath: '/support/requests/$requestId'
      preLoaderRoute: typeof SupportRequestsRequestIdRouteImport
      parentRoute: typeof SupportRoute
    }
    '/admin/analytics/_auth/': {
      id: '/admin/analytics/_auth/'
      path: '/'
      fullPath: '/admin/analytics/'
      preLoaderRoute: typeof AdminAnalyticsAuthIndexRouteImport
      parentRoute: typeof AdminAnalyticsAuthRoute
    }
    '/admin/announcements/_auth/': {
      id: '/admin/announcements/_auth/'
      path: '/'
      fullPath: '/admin/announcements/'
      preLoaderRoute: typeof AdminAnnouncementsAuthIndexRouteImport
      parentRoute: typeof AdminAnnouncementsAuthRoute
    }
    '/admin/news/_auth/': {
      id: '/admin/news/_auth/'
      path: '/'
      fullPath: '/admin/news/'
      preLoaderRoute: typeof AdminNewsAuthIndexRouteImport
      parentRoute: typeof AdminNewsAuthRoute
    }
    '/admin/organization-info/_auth/': {
      id: '/admin/organization-info/_auth/'
      path: '/'
      fullPath: '/admin/organization-info/'
      preLoaderRoute: typeof AdminOrganizationInfoAuthIndexRouteImport
      parentRoute: typeof AdminOrganizationInfoAuthRoute
    }
    '/admin/person-info/$personId/$app': {
      id: '/admin/person-info/$personId/$app'
      path: '/$app'
      fullPath: '/admin/person-info/$personId/$app'
      preLoaderRoute: typeof AdminPersonInfoPersonIdAppRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/person-info/$personId/account': {
      id: '/admin/person-info/$personId/account'
      path: '/account'
      fullPath: '/admin/person-info/$personId/account'
      preLoaderRoute: typeof AdminPersonInfoPersonIdAccountRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/person-info/$personId/consents': {
      id: '/admin/person-info/$personId/consents'
      path: '/consents'
      fullPath: '/admin/person-info/$personId/consents'
      preLoaderRoute: typeof AdminPersonInfoPersonIdConsentsRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/person-info/$personId/groups': {
      id: '/admin/person-info/$personId/groups'
      path: '/groups'
      fullPath: '/admin/person-info/$personId/groups'
      preLoaderRoute: typeof AdminPersonInfoPersonIdGroupsRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/person-info/$personId/organizations': {
      id: '/admin/person-info/$personId/organizations'
      path: '/organizations'
      fullPath: '/admin/person-info/$personId/organizations'
      preLoaderRoute: typeof AdminPersonInfoPersonIdOrganizationsRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/person-info/$personId/settings': {
      id: '/admin/person-info/$personId/settings'
      path: '/settings'
      fullPath: '/admin/person-info/$personId/settings'
      preLoaderRoute: typeof AdminPersonInfoPersonIdSettingsRouteImport
      parentRoute: typeof AdminPersonInfoPersonIdRoute
    }
    '/admin/user-management/_auth/': {
      id: '/admin/user-management/_auth/'
      path: '/'
      fullPath: '/admin/user-management/'
      preLoaderRoute: typeof AdminUserManagementAuthIndexRouteImport
      parentRoute: typeof AdminUserManagementAuthRoute
    }
  }
}

interface ProfileRouteChildren {
  ProfileEmailNotificationsRoute: typeof ProfileEmailNotificationsRoute
  ProfileGeneralSettingsRoute: typeof ProfileGeneralSettingsRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileEmailNotificationsRoute: ProfileEmailNotificationsRoute,
  ProfileGeneralSettingsRoute: ProfileGeneralSettingsRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface SupportRouteChildren {
  SupportUserFeedbacksRoute: typeof SupportUserFeedbacksRoute
  SupportRequestsRequestIdRoute: typeof SupportRequestsRequestIdRoute
  SupportRequestsIndexRoute: typeof SupportRequestsIndexRoute
}

const SupportRouteChildren: SupportRouteChildren = {
  SupportUserFeedbacksRoute: SupportUserFeedbacksRoute,
  SupportRequestsRequestIdRoute: SupportRequestsRequestIdRoute,
  SupportRequestsIndexRoute: SupportRequestsIndexRoute,
}

const SupportRouteWithChildren =
  SupportRoute._addFileChildren(SupportRouteChildren)

interface AdminPersonInfoPersonIdRouteChildren {
  AdminPersonInfoPersonIdAppRoute: typeof AdminPersonInfoPersonIdAppRoute
  AdminPersonInfoPersonIdAccountRoute: typeof AdminPersonInfoPersonIdAccountRoute
  AdminPersonInfoPersonIdConsentsRoute: typeof AdminPersonInfoPersonIdConsentsRoute
  AdminPersonInfoPersonIdGroupsRoute: typeof AdminPersonInfoPersonIdGroupsRoute
  AdminPersonInfoPersonIdOrganizationsRoute: typeof AdminPersonInfoPersonIdOrganizationsRoute
  AdminPersonInfoPersonIdSettingsRoute: typeof AdminPersonInfoPersonIdSettingsRoute
}

const AdminPersonInfoPersonIdRouteChildren: AdminPersonInfoPersonIdRouteChildren =
  {
    AdminPersonInfoPersonIdAppRoute: AdminPersonInfoPersonIdAppRoute,
    AdminPersonInfoPersonIdAccountRoute: AdminPersonInfoPersonIdAccountRoute,
    AdminPersonInfoPersonIdConsentsRoute: AdminPersonInfoPersonIdConsentsRoute,
    AdminPersonInfoPersonIdGroupsRoute: AdminPersonInfoPersonIdGroupsRoute,
    AdminPersonInfoPersonIdOrganizationsRoute:
      AdminPersonInfoPersonIdOrganizationsRoute,
    AdminPersonInfoPersonIdSettingsRoute: AdminPersonInfoPersonIdSettingsRoute,
  }

const AdminPersonInfoPersonIdRouteWithChildren =
  AdminPersonInfoPersonIdRoute._addFileChildren(
    AdminPersonInfoPersonIdRouteChildren,
  )

interface AdminPersonInfoRouteChildren {
  AdminPersonInfoPersonIdRoute: typeof AdminPersonInfoPersonIdRouteWithChildren
}

const AdminPersonInfoRouteChildren: AdminPersonInfoRouteChildren = {
  AdminPersonInfoPersonIdRoute: AdminPersonInfoPersonIdRouteWithChildren,
}

const AdminPersonInfoRouteWithChildren = AdminPersonInfoRoute._addFileChildren(
  AdminPersonInfoRouteChildren,
)

interface AdminPpnMasterdataImportRouteChildren {
  AdminPpnMasterdataImportMovedOrganizationsRoute: typeof AdminPpnMasterdataImportMovedOrganizationsRoute
  AdminPpnMasterdataImportStatusRoute: typeof AdminPpnMasterdataImportStatusRoute
}

const AdminPpnMasterdataImportRouteChildren: AdminPpnMasterdataImportRouteChildren =
  {
    AdminPpnMasterdataImportMovedOrganizationsRoute:
      AdminPpnMasterdataImportMovedOrganizationsRoute,
    AdminPpnMasterdataImportStatusRoute: AdminPpnMasterdataImportStatusRoute,
  }

const AdminPpnMasterdataImportRouteWithChildren =
  AdminPpnMasterdataImportRoute._addFileChildren(
    AdminPpnMasterdataImportRouteChildren,
  )

interface AdminAnalyticsAuthRouteChildren {
  AdminAnalyticsAuthIndexRoute: typeof AdminAnalyticsAuthIndexRoute
}

const AdminAnalyticsAuthRouteChildren: AdminAnalyticsAuthRouteChildren = {
  AdminAnalyticsAuthIndexRoute: AdminAnalyticsAuthIndexRoute,
}

const AdminAnalyticsAuthRouteWithChildren =
  AdminAnalyticsAuthRoute._addFileChildren(AdminAnalyticsAuthRouteChildren)

interface AdminAnnouncementsAuthRouteChildren {
  AdminAnnouncementsAuthIndexRoute: typeof AdminAnnouncementsAuthIndexRoute
}

const AdminAnnouncementsAuthRouteChildren: AdminAnnouncementsAuthRouteChildren =
  {
    AdminAnnouncementsAuthIndexRoute: AdminAnnouncementsAuthIndexRoute,
  }

const AdminAnnouncementsAuthRouteWithChildren =
  AdminAnnouncementsAuthRoute._addFileChildren(
    AdminAnnouncementsAuthRouteChildren,
  )

interface AdminNewsAuthRouteChildren {
  AdminNewsAuthIndexRoute: typeof AdminNewsAuthIndexRoute
}

const AdminNewsAuthRouteChildren: AdminNewsAuthRouteChildren = {
  AdminNewsAuthIndexRoute: AdminNewsAuthIndexRoute,
}

const AdminNewsAuthRouteWithChildren = AdminNewsAuthRoute._addFileChildren(
  AdminNewsAuthRouteChildren,
)

interface AdminOrganizationInfoAuthRouteChildren {
  AdminOrganizationInfoAuthIndexRoute: typeof AdminOrganizationInfoAuthIndexRoute
}

const AdminOrganizationInfoAuthRouteChildren: AdminOrganizationInfoAuthRouteChildren =
  {
    AdminOrganizationInfoAuthIndexRoute: AdminOrganizationInfoAuthIndexRoute,
  }

const AdminOrganizationInfoAuthRouteWithChildren =
  AdminOrganizationInfoAuthRoute._addFileChildren(
    AdminOrganizationInfoAuthRouteChildren,
  )

interface AdminUserManagementAuthRouteChildren {
  AdminUserManagementAuthIndexRoute: typeof AdminUserManagementAuthIndexRoute
}

const AdminUserManagementAuthRouteChildren: AdminUserManagementAuthRouteChildren =
  {
    AdminUserManagementAuthIndexRoute: AdminUserManagementAuthIndexRoute,
  }

const AdminUserManagementAuthRouteWithChildren =
  AdminUserManagementAuthRoute._addFileChildren(
    AdminUserManagementAuthRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CookiePolicyRoute: CookiePolicyRoute,
  HelpRoute: HelpRoute,
  ImprintRoute: ImprintRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ProfileRoute: ProfileRouteWithChildren,
  SupportRoute: SupportRouteWithChildren,
  AdminPersonInfoRoute: AdminPersonInfoRouteWithChildren,
  AdminPpnMasterdataImportRoute: AdminPpnMasterdataImportRouteWithChildren,
  NewsFeatureArticleIdRoute: NewsFeatureArticleIdRoute,
  NewsIndexRoute: NewsIndexRoute,
  AdminAnalyticsAuthRoute: AdminAnalyticsAuthRouteWithChildren,
  AdminAnnouncementsAuthRoute: AdminAnnouncementsAuthRouteWithChildren,
  AdminNewsAuthRoute: AdminNewsAuthRouteWithChildren,
  AdminOrganizationInfoAuthRoute: AdminOrganizationInfoAuthRouteWithChildren,
  AdminUserManagementAuthRoute: AdminUserManagementAuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
